import { FastlyImage } from '@components/common/image'
import { wrappedYear } from '@pages/wrapped'

const GradientText = ({ children }: { children: React.ReactNode }) => {
  return (
    <span
      className="block mb-2"
      style={{
        background: 'linear-gradient(270deg, #DA5E9C -0.78%, #8764B7 101.18%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
      }}
    >
      {children}
    </span>
  )
}

const PersonalizedSection = () => {
  return (
    <div className="py-10 md:py-16">
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-600 leading-tight mb-6 text-center">
        <GradientText>See what {wrappedYear} looks like.</GradientText>
      </h2>
      <div
        style={{ background: "url('/images/home/founders/box-bg.png') repeat" }}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center container mx-auto px-5 lg:px-10 py-8">
          {/* Left side - Phone mockups */}
          <div className="relative flex justify-center lg:justify-start">
            <div className="max-w-xl w-full">
              <FastlyImage
                src="images/wrapped/personalized-screen.png"
                alt="Wrapped personalized screens"
                width={485}
                height={516}
              />
            </div>
          </div>

          {/* Right side - Text content */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-600 leading-tight mb-8 text-center">
                <GradientText>Personalized wrapped.</GradientText>
                <GradientText>For our students.</GradientText>
                <span className="block">
                  <GradientText>For our teachers.</GradientText>
                </span>
              </h3>
            </div>

            <div className="space-y-4">
              <p className="text-xl lg:text-2xl text-grey-900 leading-relaxed font-500 text-center">
                Your learnings and teaching highlights, summarized and shareable
              </p>
              <p className="text-xl lg:text-2xl text-grey-900 leading-relaxed font-500 text-center">
                A year of classes, projects and progress, captured in a wrap.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PersonalizedSection
